import Component from 'e-submission/components/Card/SubmitWithoutPaymentTitle'

export default (hoc) => hoc(Component)
